import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'About Us',
        enablerKey: 'isAboutUsPageEnabled',
        href: '/about/',
        dataTn: 'footer-about-us',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_about_us" defaultMessage="About Us" />
        ),
    },
    {
        trackingLabel: 'Support Center',
        href: 'https://support.1stdibs.com/',
        target: '_blank',
        dataTn: 'footer-support',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_support" defaultMessage="Support Center" />
        ),
    },
    {
        trackingLabel: 'Questions & Answers',
        enablerKey: 'isQuestionsPageEnabled',
        href: '/answers/',
        dataTn: 'footer-qa',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.siteLinksQa" defaultMessage="Questions & Answers" />
        ),
    },
    {
        trackingLabel: 'Press',
        enablerKey: 'isPressPageEnabled',
        href: '/about/press/',
        dataTn: 'footer-press',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_press" defaultMessage="Press" />
        ),
    },
    {
        trackingLabel: 'Careers',
        enablerKey: 'isCareersPageEnabled',
        href: '/about/careers/',
        dataTn: 'footer-jobs',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_jobs" defaultMessage="Careers" />
        ),
    },
];
